<template>
  <div class="secondContent">
    <div  class="template-search-selector">
      <div class="template-types-selector-sort">
        <a href="/tupian/wanshengjie-or0-pt2-ke万圣节-pn1.html" class="tempSort router-link-exact-active router-link-active checkSort">全部</a>
        <a href="/tupian/wanshengjie-or1-pt2-ke万圣节-pn1.html" class="tempSort">照片</a>
        <a href="/tupian/wanshengjie-or2-pt2-ke万圣节-pn1.html" class="tempSort">EPS</a>
        <a href="/tupian/wanshengjie-or2-pt2-ke万圣节-pn1.html" class="tempSort">插画</a>
      </div>
    </div>
    <div class="result">
      <div class="image-view">
        <div class="preview-img-wrap_img">
          <div class="preview-image">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/new/VCG41476647212.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/new/VCG41476647212.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41496475563.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41496475563.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41157397667.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41157397667.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41624912704.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41624912704.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41507269720.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41507269720.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41518031016.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41518031016.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41157397667.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41157397667.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41624912704.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41624912704.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41507269720.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41507269720.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41518031016.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41518031016.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41157397667.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41157397667.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41624912704.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41624912704.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41507269720.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41507269720.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
            <img data-src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41518031016.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" src="http://photo-static-api.fotomore.com/creative/vcg/400/version23/VCG41518031016.jpg?uid=364&timestamp=1644569346&sign=f893cdbf3b7d776007c91ea61f2f16c3" lazy="loaded">
          </div>          
        </div>
      </div>
      <div class="paging temp-second-content-pagination" style="display: flex; justify-content: center;">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[100]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
        currentPage: 1
    };
  },
  mounted() {
    this.restaurants = this.loadAll();
  },
  methods: {
      previewImg () {
          this.$router.push({
              path: '/materialPreview'
          })
      }
  }
};
</script>

<style lang="scss" scoped>
.preview-img-wrap_img {
  position: relative;
  width: 100%;
  min-height: 80vh;

  .preview-image {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 8px);
  }
}


</style>